import { injectIntl } from "react-intl";
import React from "react";
import { OperationType, PageEnum } from "src/helpers/Enums";

const Header = (props) => {

    return (
        <div className={ "PageHeader" }>
            <div className={ "PageHeaderTitle" }>
                { PageEnum.LISTS }
            </div>
            <div className={ "flex gap-3" }>
                <div className="relative flex items-center">
                    <span className="absolute left-3">
                            <img alt={ "Logo" } src={ "/media/icons/searchIcon.svg" }
                                 className={ "h-[17px] w-[17px]" }/>
                    </span>
                    <input type="text" placeholder="Search" value={ props.search }
                           className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg outline-none"
                           onChange={ (e) => props.setSearch(e.target.value) }
                    />
                </div>
                <button className={ "PrimaryButton" }
                        onClick={ () => props.handleOpenNewList(OperationType.CREATE) }>
                    <img alt={ "Logo" } src={ "/media/icons/plusIcon.svg" } className={ "w-4 h-4" }/>
                    New List
                </button>
            </div>
        </div>
    )
}

export default injectIntl(Header);